export enum LoadingTasks {
  CreateQuotePanel = 'Create Quote Panels',
  FetchingDraftData = 'Fetch Draft Data',
  CreatingNewDraft = 'Create New Draft',
  UpdatingPortfolio = 'Update Selected Portfolios',
  UpdatingOverrides = 'Update Market Overrides',
  UploadingAttachments = 'Uploading Attachments',
  UpdatingMarkets = 'Update Layer Market Mapping',
  UpdatingDashboard = 'Update Dashboards',
  UpdateAttachment = 'Update Attachment Mapping',
  FetchingSTMData = 'Fetching Placement and Layer Details',
  UpdateTemplates = 'Update Email Templates',
  SendingEmails = 'Sending Emails',
  SendingSageLinkRequest = 'Sending Request to Sagelink',
  FetchingPreviousMarkets = 'Fetching Previous Markets',
}

export interface LoadingBlock {
  id: number
  task: LoadingTasks
}
